import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

// Components
import CustomField from "src/components/CustomField";
import Text from "src/components/Text";
import StatementInputDescription from "./StatementInputDescription";
import { parseMarkdownToElements } from "./MarkdownRenderer";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  },
  textWrapper: {
    display: "flex",
    flexDirection: "column"
  },
  customField: {
    marginBottom: 0
  },
  title: {
    fontSize: 13
  },
  body: {
    fontSize: "13px"
  },
  listWrapper: {
    margin: 0,
    padding: theme.spacing(0, 3)
  },
  listItem: {
    fontSize: "13px"
  }
}));

const StatementInput = ({ data, name, ...props }) => {
  const classes = useStyles();
  const isBoolean = data.type === "boolean";
  const isStaticText = data.type === "staticText";

  if (isStaticText)
    return (
      <StatementInputDescription
        content={parseMarkdownToElements(
          data.properties?.content || data.properties?.text || "",
          null,
          null,
          classes
        )}
      />
    );

  return (
    <Box className={classes.root}>
      {isBoolean ? (
        <Text type="heading3">{data.title}</Text>
      ) : (
        <Box className={classes.textWrapper}>
          <Text type="heading3">{data.label}</Text>
          <Text type="body" className={classes.title}>
            {data.title}
          </Text>
        </Box>
      )}
      <CustomField
        className={classes.customField}
        name={name}
        type={data.type}
        label={isBoolean && data.label}
        maxLength={data.validation?.maxLength}
        isNumber={data.isNumber}
        min={data.minimum}
        literalOptionText={data.literalOptionText}
        multiline={data.multiline}
        enableFuture={data.enableFuture}
        options={data.properties.options}
        placeholder={data.properties.placeholder}
        minRows={3}
        {...props}
      />
    </Box>
  );
};

StatementInput.propTypes = {
  data: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    maxLength: PropTypes.number,
    minimum: PropTypes.number,
    isNumber: PropTypes.bool,
    literalOptionText: PropTypes.bool,
    multiline: PropTypes.bool,
    enableFuture: PropTypes.bool,
    properties: PropTypes.shape({
      options: PropTypes.arrayOf(PropTypes.shape({})),
      placeholder: PropTypes.string,
      content: PropTypes.string,
      text: PropTypes.string
    }),
    validation: PropTypes.shape({
      maxLength: PropTypes.number
    })
  }).isRequired,
  name: PropTypes.string.isRequired
};

export default StatementInput;
